export const getSession = (key: string) => {
  return sessionStorage.getItem(key) as string;
};

export const setSession = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};
